module.exports = __webpack_public_path__ + "static/check-your-mail-charlie-brown-f8fb6a03dcde10cfe2ddaa52f47e0392.jpg";